export const SET_BLOCK_HEIGHT = 'SET_BLOCK_HEIGHT'
export const SET_ONTID_INFO = 'SET_ONTID_INFO'
export const SET_ONTID_PROJECT_INFO = 'SET_ONTID_PROJECT_INFO'
export const SET_PROJECT_USER_INFO = 'SET_PROJECT_USER_INFO'
export const EMPTY_ONTID_INFO = 'EMPTY_ONTID_INFO'
export const SET_REGISTER_INFO = 'SET_REGISTER_INFO'
export const EMPTY_REGISTER_INFO = 'EMPTY_REGISTER_INFO'
export const SET_PROJECT_LIST = 'SET_PROJECT_LIST'
export const SET_PROJECT_INFO = 'SET_PROJECT_INFO'
export const SET_PUBLIC_LIBRARY_PROJECT = 'SET_PUBLIC_LIBRARY_PROJECT'
export const SET_PROJECT_TEMPLATE = 'SET_PROJECT_TEMPLATE'
export const SET_PROJECT_TEMPLATE_CODE = 'SET_PROJECT_TEMPLATE_CODE'
export const SET_PROJECT_NAME = 'SET_PROJECT_NAME'
export const SET_DEPLOY_WALLET_INFO = 'SET_DEPLOY_WALLET_INFO'
export const SET_DEPLOY_INFO = 'SET_DEPLOY_INFO'
export const SET_DEPLOY_FEE = 'SET_DEPLOY_FEE'
export const SET_DEPLOY_CONTRACT_INFO = 'SET_DEPLOY_CONTRACT_INFO'
export const CLEAR_DEPLOY_CONTRACT_INFO = 'CLEAR_DEPLOY_CONTRACT_INFO'
export const SET_RUN_WALLET_INFO = 'SET_RUN_WALLET_INFO'
export const SET_RUN_FEE = 'SET_RUN_FEE'
export const SET_RUN_OPTION = 'SET_RUN_OPTION'
export const SET_RUN_STATUS = 'SET_RUN_STATUS'
export const RUN_WASM_FUNCTION_PARAMS = 'RUN_WASM_FUNCTION_PARAMS'
export const SET_CONTRACT_HASH = 'SET_CONTRACT_HASH'
export const CLEAR_CONTRACT_HASH = 'CLEAR_CONTRACT_HASH'
export const SET_COMPILE_INFO = 'SET_COMPILE_INFO'
export const SET_COMPILE_SESSION_INFO = 'SET_COMPILE_SESSION_INFO'
export const CLEAR_COMPILE_INFO = 'CLEAR_COMPILE_INFO'
export const SET_WAT_MEMORY ='SET_WAT_MEMORY'
export const SET_PROJECT_CODE = 'SET_PROJECT_CODE'
export const HAVE_RE_COMPILE = 'HAVE_RE_COMPILE'
export const ADD_GITHUB_INFO_FALSE= 'ADD_GITHUB_INFO_FALSE'
export const ADD_ONTID_INFO_FALSE = 'ADD_ONTID_INFO_FALSE'
export const SET_COMPILE_AVM = 'SET_COMPILE_AVM'

export const APPEND_OUTPUT_LOG = 'APPEND_OUTPUT_LOG'
export const APPEND_OUTPUT_EVENT = 'APPEND_OUTPUT_EVENT'
export const CLEAR_OUTPUT_LOGS = 'CLEAR_OUTPUT_LOGS'
export const CLEAR_OUTPUT_EVENTS = 'CLEAR_OUTPUT_EVENTS'

export const APPEND_WASM_OUTPUT = 'APPEND_WASM_OUTPUT'
export const CLEAR_WASM_OUTPUT = 'CLEAR_WASM_OUTPUT'
export const SET_WASM_ABI_FUNCTION = 'SET_WASM_ABI_FUNCTION'
export const SET_WASM_ABI_FUNCTION_ABI = 'SET_WASM_ABI_FUNCTION_ABI'
export const CLEAR_WASM_ABI_FUNCTION = 'CLEAR_WASM_ABI_FUNCTION'

export const SET_AVM = 'SET_AVM'


export const SET_EDITOR = 'SET_EDITOR'

export const LOGOUT = 'LOGOUT'

export const SET_USER_GITHUB_INFO = 'SET_USER_GITHUB_INFO'

export const SET_MODAL_TITLE = 'SET_MODAL_TITLE'
export const SET_MODAL_CONTENT = 'SET_MODAL_CONTENT'
export const SET_MODAL_SHOW_CLOSE_BUTTON = 'SET_MODAL_SHOW_CLOSE_BUTTON'

export const SET_DEBUGGER = 'SET_DEBUGGER'
export const SET_DEBUGGER_STATE = 'SET_DEBUGGER_STATE'

export const SET_TEST_ACCOUNT = 'SET_TEST_ACCOUNT'
export const SET_TEST_FUNCTION_JSON = 'SET_TEST_FUNCTION_JSON'



// WEBPACK FOOTER //
// ./src/store/mutation-type.js